export const clinic = {
  name: "RD-Kiné",
  tagline: "Cabinet paramédical à Étréchy",
  street: "14 rue de l'Amandier",
  city: "91580 Étréchy",
  phone: "09 60 53 05 76",
  phoneHref: "tel:+33960530576",
  mapEmbed:
    "https://www.openstreetmap.org/export/embed.html?bbox=2.1865%2C48.4900%2C2.1985%2C48.4975&layer=mapnik&marker=48.4937%2C2.1925",
  mapLink: "https://www.openstreetmap.org/?mlat=48.4937&mlon=2.1925#map=17/48.4937/2.1925",
};

export const accessNotes = [
  "À côté de la Mairie",
  "1 min à pied de la Grande Rue",
  "3 min à pied de la gare RER C",
];

export const openingHours = [
  { day: "Lundi – Vendredi", hours: "8h00 – 12h30 · 14h00 – 20h00" },
  { day: "Samedi", hours: "8h00 – 12h30" },
  { day: "Dimanche", hours: "Fermé" },
];

export const socialLinks = [
  { label: "Instagram", href: "https://www.instagram.com/" },
  { label: "Facebook", href: "https://www.facebook.com/" },
  { label: "LinkedIn", href: "https://www.linkedin.com/" },
];
